export default {
  header: "Advertencia",
  dataloss_1:
    "Está a punto de abandonar esta página. Sus entradas o cambios durante esta sesión no se guardarán. ¿Realmente desea abandonar esta página? No (volver) / Sí (abandonar página)",
  changedata:
    "Por favor, confirme que tiene derecho a cambiar los datos manualmente y que los nuevos datos son correctos.",
  changeobject:
    "Este <nombre del objeto> ha sido actualizado por última vez por el usuario <dirección de correo del usuario que actualizó por última vez el objeto> (<marca de tiempo>). Por favor confirme que tiene derecho",
  blockobject:
    "Este <nombre del objeto> está siendo editado actualmente por el usuario <dirección de correo del usuario que bloquea el objeto> y no se puede cambiar en este momento. Inténtelo de nuevo en 15 minutos o pídale al otro usuario que cancele la edición.",
  dataloss_2: "¿Realmente desea eliminar? ",
  dataloss_2_header: "¡El registro será eliminado!",
  confirmDeleteGroup: "¿Realmente desea eliminar este grupo?",
  confirmDeleteRule: "¿Realmente desea eliminar esta regla?",
  confirmImportTitle: "¿Recargar formulario?",
  confirmLeaveForm: "¿Realmente desea abandonar la página? Los posibles cambios no se guardarán.",
  confirmLeaveFormTitle: "¿Abandonar página?",
  changesSavedTitle: "Cambios guardados",
  errorTypeFile: "¡Tipo de archivo no soportado!",
  changesSavedMessage: "Sus cambios se han guardado correctamente.",
  confirmLogout: "¿Está seguro de que desea cerrar sesión?",
  logoutTitle: "¿Cerrar sesión?",
};
